export default __webpack_public_path__ + "8e62ee4dbc88707b4ab3f3de8f72e115.jpg";